'use client';

import { MenuOpen } from '@mui/icons-material';
import { AppShellTriggerIcon } from '../../layouts/app-shell/app-shell-trigger-icon';
import { useAppShell } from '../../layouts/app-shell/context';
import { SideToShowOption } from '../../layouts/app-shell/types';

export const SidebarToggle = () => {
  const { sideToShow } = useAppShell();

  if (
    sideToShow === SideToShowOption.OnlyLeft ||
    sideToShow === SideToShowOption.LeftAndRight
  ) {
    return null;
  }

  return (
    <AppShellTriggerIcon actionType="open">
      <MenuOpen sx={{ transform: 'rotate(180deg)' }} />
    </AppShellTriggerIcon>
  );
};
